/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Offline_MsgInputs */



/**
* | output |
* | --- |
* | "Your profile loads once Archon can reach the server again." |
*
* @param {Profile_Offline_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_offline_msg = /** @type {((inputs?: Profile_Offline_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Offline_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre profil se chargera dès qu'Archon pourra de nouveau joindre le serveur.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tu perfil se cargará en cuanto Archon pueda volver a conectar con el servidor.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seu perfil será carregado assim que o Archon conseguir acessar o servidor novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tuo profilo si caricherà non appena Archon potrà di nuovo raggiungere il server.")
	return /** @type {LocalizedString} */ ("Your profile loads once Archon can reach the server again.")
});